import * as React from 'react';
import styles from './slider-rating.scss';
import { Tooltip } from 'ui/common/tooltip/tooltip';
import debounce from 'lodash/debounce';

export interface SliderCaptionProps {
  bars: { description: string }[];
  active: number;
  isRtl?: boolean;
  visibleOnMobile?: boolean;
}
interface SliderCaptionItemProps {
  description: string;
  active: boolean;
}

interface SliderCaptionItemState {
  tooltip: boolean;
}
export class SliderCaptionItem extends React.Component<SliderCaptionItemProps, SliderCaptionItemState> {
  private labelRef: React.RefObject<HTMLDivElement>;
  private debouncedResize: any;

  constructor(props: SliderCaptionItemProps) {
    super(props);

    this.state = {
      tooltip: false
    };

    this.labelRef = React.createRef();

    this.debouncedResize = debounce(() => {
      this.useTooltip();
    }, 200);
  }

  private useTooltip() {
    const el = this.labelRef.current;
    if (!el) {
      return;
    }
    const showTooltip = el.offsetHeight !== el.scrollHeight;

    if (showTooltip !== this.state.tooltip) {
      this.setState({ tooltip: showTooltip });
    }
  }

  public componentDidMount() {
    this.useTooltip();
    window.addEventListener('resize', this.debouncedResize);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResize);
  }

  public render() {
    const { description, active } = this.props;
    const { tooltip } = this.state;

    const label = <div ref={this.labelRef} className={styles.caption}>
      {description}
    </div>;

    return (
      <div className={`${styles.captionOuterBox} ${active ? styles.active : ''}`}
        data-testid={active ? 'slider-caption-item-active' : 'slider-caption-item'}>
        {tooltip ? (
          <Tooltip className={styles.tooltipOverwrite} title={description} center delayed>
            {label}
          </Tooltip>)
          :
          label
        }
      </div>
    );
  }
}

export const SliderCaption: React.FC<SliderCaptionProps> = props => {
  const { visibleOnMobile = false, isRtl, bars, active } = props;
  const rtlStyle = isRtl && styles.captionBoxReverse;
  const dataTestId = visibleOnMobile ? 'slider-caption-box-line' : 'slider-caption-box-labels';

  return (
    <div className={`${styles.captionBox} ${rtlStyle}`} data-testid={dataTestId}>
      {bars.map((item, index) => (
        <SliderCaptionItem active={index === active} description={item.description} key={index} />
      ))}
    </div>
  );
};
SliderCaption.displayName = 'SliderCaption';
